type NickableModel = { nick?: string; ori?: string };

/**
 * Normalizes and preserves the user-set `nick` field across vault sync operations.
 *
 * Rules:
 * - Incoming nick is trimmed; empty string is treated as explicit removal.
 * - If existing model has a nick and incoming omits it (undefined), preserve it
 *   for non-manual accounts only.
 * - Manual accounts never retain a nick.
 */
export function preserveNick(incoming: NickableModel, existing: NickableModel | undefined): void {
  // Track whether incoming explicitly provided a nick value (even empty) before normalization.
  // Empty string means "user cleared the nick" — different from undefined which means "not provided".
  const incomingExplicitlySetNick = incoming.nick !== undefined;

  if (incomingExplicitlySetNick) {
    incoming.nick = incoming.nick.trim();
    if (incoming.nick === "") {
      delete incoming.nick;
    }
  }

  // Only preserve existing nick when incoming truly omitted the field (sync path — no nick data).
  // When incoming had an explicit value (even empty), honour that intent.
  if (!incomingExplicitlySetNick && existing?.nick) {
    if (existing.ori !== "manual") {
      incoming.nick = existing.nick;
    } else {
      delete incoming.nick;
    }
  }
}
